import { render, staticRenderFns } from "./EditChromatogramAppearanceModal.vue?vue&type=template&id=0e88d3b5&scoped=true&"
import script from "./EditChromatogramAppearanceModal.vue?vue&type=script&lang=js&"
export * from "./EditChromatogramAppearanceModal.vue?vue&type=script&lang=js&"
import style0 from "./EditChromatogramAppearanceModal.vue?vue&type=style&index=0&id=0e88d3b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e88d3b5",
  null
  
)

export default component.exports